import { MessageDescriptor } from "react-intl";

import { BulkExportPayload, SavedBulkExportPayload } from "../../../subscriptions/types";
import { IDimension } from "../../types";

import messages from "./SubscriptionProvider.messages";

export function validatePayload(payload: BulkExportPayload | SavedBulkExportPayload) {
  const errors: Partial<Record<keyof BulkExportPayload | keyof SavedBulkExportPayload, MessageDescriptor>> = {};

  // if BulkExportPayload
  if ("dimensions" in payload) {
    if (!isAllDimensionsFilled(payload.dimensions, payload.measures)) {
      errors.dimensions = messages.emptySelection;
    }
  }

  return Object.keys(errors).length === 0 ? null : errors;
}

function isAllDimensionsFilled(dimensions: IDimension[], measures: BulkExportPayload["measures"]) {
  const isMainDimensionsFilled = dimensions.every((dim) => dim.selection.length !== 0);
  const isConfiguarationFilled = dimensions.some((dim) => dim.fieldName !== "") || measures.length !== 0;
  return isMainDimensionsFilled && isConfiguarationFilled;
}
